import React from 'react';
import { Form } from '@kuzmycz/react-form-ula';
import { Button, Modal } from '../../../../Components/uielements';
import BioPlusTextField from '../../../../Components/form-fields/BioPlusTextField';
import {
  ModalButtonWrapper,
  ModalGap,
  ModalWrapper,
  OutlineButton,
} from '../../../../services/settings/appStyle/global.style';
import { useUserContext } from '../../../../hooks/UserContext';
import { InviteCompanySchema } from '../validator/inviteCompanyValidator';
import CompanyService from '../../../../services/bioplus-services/company';

const InviteCompanyModal = ({ onClose }) => {
  const userContext = useUserContext();

  const validator = (values) => {
    return InviteCompanySchema.validate(values);
  };

  const handleSubmit = async (values) => {
    const { companyId, ...form } = values;

    await CompanyService.inviteCompany(companyId, form);
  };

  const companyId = userContext?.company?.companyId?.id;
  const companyName = userContext?.company?.companyName;

  return (
    <>
      <Modal isOpen={true} onClose={onClose} title="Invite Entity">
        <Form
          initialValues={{ companyId: companyId, companyName: companyName }}
          validator={validator}
          onSubmit={handleSubmit}
        >
          <ModalWrapper>
            <ModalGap>
              <BioPlusTextField label="Entity Name" name="targetCompany" fullWidth />
              <BioPlusTextField label="Email" name="email" fullWidth />
              <BioPlusTextField label="Message" name="message" fullWidth />
            </ModalGap>
            <ModalButtonWrapper>
              <OutlineButton onClick={onClose}>Cancel</OutlineButton>
              <Button varient="normal" type="submit">
                Submit
              </Button>
            </ModalButtonWrapper>
          </ModalWrapper>
        </Form>
      </Modal>
    </>
  );
};

export default InviteCompanyModal;
